<template>
  <div data-name="summary-table"
    class="row"
    role="presentation">
    <el-table :data="portSummary"
      class="col-12"
      show-summary
      sum-text="Total">
      <el-table-column sortable
        prop="name"
        :label="labels.name">
        <template slot-scope="scope">
          <router-link :to="getUrl(scope.row.name)">
            {{ scope.row.name }}
          </router-link>
        </template>
      </el-table-column>

      <el-table-column sortable
        prop="total"
        label="Total Ports Ordered" />

      <el-table-column sortable
        prop="new"
        label="Waiting Infrastructure" />

      <el-table-column sortable
        prop="deployable"
        label="Future Request Date" />

      <el-table-column sortable
        prop="configured"
        label="Configured" />

      <el-table-column sortable
        prop="live"
        label="Fully Provisioned" />
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'SummaryTable',

  props: {
    portSummary: {
      type: Array,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tableFields: [
        {
          key: '',
          lable: '',
          sortable: true,
        },
      ],
    }
  },

  methods: {
    getUrl(location) {
      if (this.labels.name === 'City') {
        return `/services-by/city/${location}`
      }
      return `/services-by/country/${location}`
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1rem;
}
</style>

<style lang="scss">
html[data-theme='dark'] [data-name="summary-table"] {
  .el-table,
  .el-table__header-wrapper,
  .el-table__body-wrapper,
  .el-table__footer-wrapper {
    background-color: var(--box-bg) !important;
  }

  .el-table__header,
  .el-table__body,
  .el-table__footer {
    background-color: var(--box-bg) !important;
  }

  .el-table tr,
  .el-table th,
  .el-table td {
    background-color: var(--box-bg) !important;
    color: var(--text-primary) !important;
  }

  .el-table th.el-table__cell {
    background-color: var(--bg-secondary) !important;
  }

  .el-table__cell .cell {
    color: var(--text-primary) !important;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: var(--bg-secondary) !important;
  }

  // Subtle borders
  .el-table {
    border-color: var(--border-light) !important;

    &::before,
    &::after {
      background-color: var(--border-light) !important;
    }
  }

  .el-table td.el-table__cell,
  .el-table th.el-table__cell {
    border-bottom: 1px solid var(--border-light) !important;
  }

  .el-table--border .el-table__cell {
    border-right: 1px solid var(--border-light) !important;
  }

  .el-table__inner-wrapper::before {
    background-color: var(--border-light) !important;
  }
}
</style>
